import { useNavigate } from 'react-router-dom';
import Button from './Button';

/**
 * The one empty state for the pages that only show events you are going to: Maps, Sets, Groups, Find (Sam,
 * 2026-10-12: "a very concise message and a button that redirects them to the Events page"). One line, one button.
 * `action` swaps the button when there is something better to open than Events.
 */
export default function NothingYoursYet({ text, className = '', action = null }) {
  const navigate = useNavigate();
  return (
    <div className={`py-16 text-center ${className}`}>
      <p className="text-[15px] text-[#94a3b8]">{text}</p>
      <Button className="mt-4" onClick={() => navigate(action?.to ?? '/')}>
        {action?.label ?? 'Find events'}
      </Button>
    </div>
  );
}
